import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import Marcas from "@/pages/Marcas";

export const Route = createFileRoute("/marcas/")({
  head: () => seoHead({
    title: "Marcas Parceiras | Shopping do Bem",
    description: "Conheça as +300 marcas parceiras do Shopping do Bem. Compre e doe sem custo extra.",
    path: "/marcas",
  }),
  component: Marcas,
});
